import { RouteConfig } from 'vue-router';
import * as handlers from '../handlers';

const routes: Array<RouteConfig> = [
  {
    path: 'superseded',
    component: () => import('@/pages/error/ErrorPackageSupersededPage.vue'),
    meta: {
      back: handlers.home
    }
  },
  {
    path: 'current',
    component: () => import('@/pages/error/ErrorPackageCurrentPage.vue'),
    meta: {
      back: handlers.home
    }
  },
  {
    path: 'declined',
    component: () => import('@/pages/error/ErrorPackageDeclinedPage.vue'),
    meta: {
      back: handlers.home
    }
  },
  {
    path: 'expired',
    component: () => import('@/pages/error/ErrorPackageExpiredPage.vue'),
    meta: {
      back: handlers.home
    }
  },
];

export default routes;
